import API from "@/api";

const state = {
  pendingApprovals: []
};

const getters = {
  pendingApprovals: (state) => state.pendingApprovals,
  approvalCount: (state, getters) => getters.pendingApprovals.length
};

const mutations = {
  setPendingApprovals(state, payload) {
    state.pendingApprovals = payload;
  },
  respondApproval(state, payload) {
    const index = state.pendingApprovals.findIndex(el => el.id === payload.id);
    if(index === -1) return;
    state.pendingApprovals.splice(index, 1)
  }
};

const actions = {
  setPendingApprovals(context, payload){
    context.commit('setPendingApprovals', payload);
  },
  getApprovals(context, payload){
    return new Promise(async (resolve, reject) => {
      try {
        const {data} = await API.getResponderBenefitApprovals();
        const pendingApprovals = data.benefitApprovalRequests
        await context.dispatch('setPendingApprovals', pendingApprovals);
        resolve(pendingApprovals);
      } catch (e) {
        console.error(e);
        reject(e);
      }
    })

  },
  submitApprovalResponse(context, payload) {
    const {id, status, responderNotes} = payload;
    return new Promise((resolve, reject) => {
      if (!(id && status)) reject(new Error('Missing details required to respond to benefit approval request'));
      API.respondBenefitApproval({
        id,
        status,
        responderNotes
      })
        .then(({data}) => {
          context.commit('respondApproval', {id, status, responderNotes});
          resolve(data.updatedBenefitApproval);
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        })
    })
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}
